import { NgModule, Component } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'

// Layouts
import { FullLayoutComponent } from './layouts/full-layout.component'
//
import { MarketLevelComponent } from 'app/market-level/market-level/market-level.component'
import { MarketPerformanceComponent } from 'app/market-level/market-performance/market-performance.component'
import { CapitalRaisedInstrumentsComponent } from 'app/market-level/capital-raised-instruments/capital-raised-instruments.component'
import { CapitalRaisedIpoSoComponent } from 'app/market-level/capital-raised-ipo-so/capital-raised-ipo-so.component'
import { HistoricalIndicesComponent } from 'app/market-level/historical-indices/historical-indices.component'
import { ExistingListedSecuritiesComponent } from 'app/market-level/existing-listed-securities/existing-listed-securities.component'
import { MarketLevelWatchListComponent } from './market-level/market-level-watch-list/market-level-watch-list.component'
import { WatchListComponent } from './market-level/watch-list/watch-list.component'
import { GlobalIndexMemberComponent } from './market-level/global-index-member/global-index-member.component'
import { CompareExchangesComponent } from './market-level/compare-exchanges/compare-exchanges.component'
import { InitialPublicOfferingComponent } from './market-level/initial-public-offering/initial-public-offering.component'
import { AseanExchangesComponent } from './market-level/asean-exchanges/asean-exchanges.component'
import { MarcroDataComponent } from './market-level/marcro-data/marcro-data.component'
import { ProfitDataComponent } from './market-level/profit-data/profit-data.component'
import { MarketCapRankPeComponent } from './market-level/market-cap-rank-pe/market-cap-rank-pe.component'
import { MarketCapRankTopSecurityComponent } from './market-level/market-cap-rank-top-security/market-cap-rank-top-security.component'
import { IpoExchangeIn5YearComponent } from './market-level/ipo-exchange-in-5-year/ipo-exchange-in-5-year.component'
import { IndustryLevelComponent } from './industry-level/industry-level/industry-level.component'
import { SectorPopupDataComponent } from './industry-level/sector-popup-data/sector-popup-data.component'
import { SectorProfitDataComponent } from './industry-level/sector-profit-data/sector-profit-data.component'
import { SectorPopupComponent } from './industry-level/sector-popup/sector-popup.component'
import { SecuritiesLevelComponent } from './securities-level/securities-level/securities-level.component'
// tslint:disable-next-line:max-line-length
import { BodScreenComponent } from './securities-level/bod/bod-screen/bod-screen.component'
import { ExecutiveSummaryComponent } from './securities-level/executive-summary/executive-summary.component'
import { BoardShareholderComponent } from './securities-level/board-shareholder/board-shareholder.component'
import { TradingComponent } from './securities-level/trading/trading.component'
import { AdditionalInfoComponent } from './securities-level/additional-info/additional-info.component'
import { CrmScreenComponent } from './crm/crm-screen/crm-screen.component'
import { OutputComponent } from './crm/output/output.component'
import { ContactComponent } from './crm/contact/contact.component'
import { FinancialComponent } from './securities-level/financial/financial.component'
import { AeSummaryComponent } from './crm/ae-summary/ae-summary.component'
import { LoginComponent } from './login/login.component'
import { CorporateScreenComponent } from './securities-level/corporate-action/corporate-screen/corporate-screen.component'
// tslint:disable-next-line:max-line-length
import { RevenueContributionScreenComponent } from './securities-level/revenue-contribution/revenue-contribution-screen/revenue-contribution-screen.component'
import { FullFactSheetScreenComponent } from './securities-level/full-fact-sheet/full-fact-sheet-screen/full-fact-sheet-screen.component'
import { CompanyAeComponent } from './admin/company-ae/company-ae.component'
import { AdminComponent } from './admin/admin/admin.component'

const printableComponents = [
  {
    path: 'marketCapPeRank',
    data: { print: true },
    component: MarketCapRankPeComponent
  },
  {
    path: 'marketCapSecurityRank/:topRank/:checkedIndustries',
    data: { print: true },
    component: MarketCapRankTopSecurityComponent
  },
  {
    path: 'globalIndexComposition/:radioValue',
    data: { print: true },
    component: GlobalIndexMemberComponent
  },
  {
    path: 'marketPerformance/:ytdValue',
    data: { print: true },
    component: MarketPerformanceComponent
  },
  {
    path: 'capitalRaisedInstrument/:capitalValue/:capitalType',
    data: { print: true },
    component: CapitalRaisedInstrumentsComponent
  },
  {
    path: 'capitalRaisedIpo/:ytdValue2',
    data: { print: true },
    component: CapitalRaisedIpoSoComponent
  },
  {
    path: 'historicalIndices/:marketValue',
    data: { print: true },
    component: HistoricalIndicesComponent
  },
  {
    path: 'historicalIndices',
    data: { print: true },
    component: HistoricalIndicesComponent
  },
  {
    path: 'existingListedSecurities',
    data: { print: true },
    component: ExistingListedSecuritiesComponent
  },
  {
    path: 'marketWatchList/:currentItem',
    data: { print: true },
    component: WatchListComponent
  },
  {
    path: 'initalPublicofferingTop10/:ipoValue',
    data: { print: true },
    component: AseanExchangesComponent
  },
  {
    path: 'ipoExchangeIn5Year/:currentItem',
    data: { print: true },
    component: IpoExchangeIn5YearComponent
  },
  {
    path: 'marcroData',
    data: { print: true },
    component: MarcroDataComponent
  },
  {
    path: 'profitdata',
    data: { print: true },
    component: ProfitDataComponent
  },
  {
    path: 'sectorPopup/:radioByView/:radioByFinancial',
    // data: { print: true },
    component: SectorPopupComponent
  },
  {
    path: 'sectorPopup/:radioByView/:radioByFinancial/:indexN/:marketL/:indexL',
    // data: { print: true },
    component: SectorPopupComponent
  },
  {
    path: 'sectorPopupData/:radioByView/:radioByFinancial/:indexN/:marketL/:indexL',
    data: { print: true },
    component: SectorPopupDataComponent
  },
  {
    path: 'sectorProfitData/:radioByView',
    data: { print: true },
    component: SectorProfitDataComponent
  },
  {
    path: 'executiveSummary/:symbol',
    data: { print: true },
    component: ExecutiveSummaryComponent
  },
  {
    path: 'boardShareholder/:symbol/:freeFloat/:majorShare',
    data: { print: true },
    component: BoardShareholderComponent
  },
  {
    path: 'additionalInfo/:symbol',
    data: { print: true },
    component: AdditionalInfoComponent
  },
  {
    path: 'trading/:symbol/:period/:type/:pricePerType',
    data: { print: true },
    component: TradingComponent
  },
  {
    path: 'crmoutput/:symbol/:caseId',
    data: { print: true },
    component: OutputComponent
  },
  {
    path: 'contact/:symbol/:printCase',
    data: { print: true },
    component: ContactComponent
  },
  {
    path: 'financial/:symbol',
    data: { print: true },
    component: FinancialComponent
  },
  {
    path: 'crmaesummary/:yearByTeam/:yearByIndividual',
    data: { print: true },
    component: AeSummaryComponent
  },
  {
    path: 'corporate/:symbol',
    data: { print: true },
    component: CorporateScreenComponent
  },
  {
    path: 'fullfactsheet/:symbol/:period',
    data: { print: true },
    component: FullFactSheetScreenComponent
  }
]

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: '',
    component: FullLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: './dashboard/dashboard.module#DashboardModule'
      },
      {
        path: 'market-level/market-level',
        component: MarketLevelComponent
      },
      {
        path: 'market-level/compare-exchanges',
        component: CompareExchangesComponent
      },
      {
        path: 'industry-level/industry-level',
        component: IndustryLevelComponent
      },
      {
        path: 'securities-level/excecutive-summary',
        component: SecuritiesLevelComponent
      },
      {
        path: 'securities-level/trading',
        component: TradingComponent
      },
      {
        path: 'securities-level/financial',
        component: FinancialComponent
      },
      {
        path: 'crm/crm',
        component: CrmScreenComponent
      },
      {
        path: 'securities-level/corporateaction',
        component: CorporateScreenComponent
      },
      {
        path: 'securities-level/revenuecontribution',
        component: RevenueContributionScreenComponent
      },
      {
        path: 'admin/admin',
        component: AdminComponent
      },
      {
        path: 'admin/company-ae',
        component: CompanyAeComponent
      }
    ]
  },
  ...printableComponents,
  {
    path: 'pdf',
    data: { pdf: true },
    children: [...printableComponents]
  }
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/app.routing.ts